import { LoadState } from "../../constants/enums";

export interface IModuleSetting {
  master_module_setting_id: number;
  master_module_setting_unique_id: number;
  master_module_setting_uuid: string;
  module_name: string;
  setting_name: string;
  setting_key: string;
  value_datatype: string;
  default_value: string;
  is_encrypted: number;
  show_only_to_enr_admin: number;
  status: string;
  created_by_uuid: string;
  created_by_name: string | null;
  modified_by_uuid: string;
  modified_by_name: string | null;
  create_ts: string;
  insert_ts: string;
  setting_value: string | null;
  company_outlet_module_setting_uuid: string | null;
  company_outlet_uuid: string;
}

export interface IModuleSettingState {
  list: IModuleSetting[];
  loading: LoadState;
  totalRecords: number;
}

export const initialModuleSettingState: IModuleSettingState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
};
